import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBoxesQuestion from '../components/MultiSelectBoxesQuestion';

const answerOptions = [
  {id: 1, label: 'Acquired Brain Injury'},
  {id: 2, label: 'Autism'},
  {id: 3, label: 'Vision Impairment'},
  {id: 4, label: 'Families'},
  {id: 5, label: 'Intellectual Disability'},
  {id: 6, label: 'LGBTIQ+'},
  {id: 7, label: 'Indigenous Culture'},
  {id: 8, label: 'Foreign Language Speaker'},
];

const ConsiderationsQuestion = ({data, handleAnswer}) => {
  return (
    <MultiSelectBoxesQuestion
      question="Please tick any of these considerations which apply (optional)"
      item="considerations"
      data={data}
      answerOptions={answerOptions}
      handleAnswer={handleAnswer}
    />
  );
};

ConsiderationsQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default ConsiderationsQuestion;
